import {
  consultantsSearchSchema,
  consultantsViewColumns,
  mapConsultantsViewQuery,
} from "./ConsultantsView.default";
import ManagedGridView from "../controls/ManagedGridView";
import { SearchQuery } from "../code/search-query/search-query";
import { getConsultants } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

export interface ConsultantsViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function ConsultantsView(props: ConsultantsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={consultantsViewColumns}
      schema={consultantsSearchSchema}
      mapQuery={mapConsultantsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getConsultants, { retry: true })}
      actions={[
        {
          key: "view",
          label: "View",
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("PlatformConsultants", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default ConsultantsView;
